import { BaseApi } from './base.api.js';

export class ContextApi extends BaseApi {
    constructor(client) {
        super(client, '/context');
    }
}
